
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType = typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType[keyof typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
